// extracted by mini-css-extract-plugin
export var buttonsContainer = "header-mobile-module--buttonsContainer--a75c8";
export var genericContainer = "header-mobile-module--genericContainer--cf448";
export var header = "header-mobile-module--header--e70b2";
export var logo = "header-mobile-module--logo--9e49a";
export var menuContainer = "header-mobile-module--menuContainer--5be7c";
export var modalContent = "header-mobile-module--modalContent--41f75";
export var subscribeButton = "header-mobile-module--subscribeButton--a6629";